<template>
  <v-card>
    <v-card-title>
      <div>
        <div class="headline">Permitted Member Groups</div>
      </div>
      <v-spacer></v-spacer>
      <v-flex xs6>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-flex>
    </v-card-title>
    <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="groupId" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
      <template slot="items" slot-scope="props">
        <td>{{ props.item.groupId }}</td>
        <td class="text-xs-left">{{ props.item.groupDesc }}</td>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      headers: [
        { text: 'Group ID', align: 'left', value: 'groupId', sortable: false },
        { text: 'Group Description', align: 'left', value: 'groupDesc', sortable: false }
      ],
      totalItems: 0,
      loading: false,
      items: []
    }
  },
  methods: {
    async doInit() {
      await this.queryPromotionMemberGroups()
    },
    async queryPromotionMemberGroups() {
      const apiURI = this.$store.state.promotionManagement.promotion.menu.promotionMemberGroups
      if (apiURI) {
        try {
          this.loading = true
          const expand = {
            promotion: this.promotion
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              this.items = []
              data.map((promotionMemberGroup) => {
                const convertPromotionMemberGroup = {
                  promotion: promotionMemberGroup.promotion,
                  promotionDesc: promotionMemberGroup.promotionDesc,
                  groupId: promotionMemberGroup.groupId,
                  groupDesc: promotionMemberGroup.groupDesc
                }
                this.items.push(convertPromotionMemberGroup)
              })
            } else {
              this.items = []
            }
          }
          this.loading = false
        } catch (err) {
          throw err
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    }
  },
  props: {
    promotion: {
      type: String,
      default: ''
    }
  },
  created() {
    this.doInit()
  },
  mixins: [
    TableConst.default
  ]
}
</script>

<style lang="scss">
</style>
